module.exports = __webpack_public_path__ + "static/images/clock.5d3e0c24de5236996b28abe7314b87d3.svg";